import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import '../../ContextMenu.scss';

const ContextMenu = ({children, sequencerEngine, dropdownPos, setDropdownPos, className}) => { 
    if (!dropdownPos) { return []; }
    return (
        <div style={
            {
                left: dropdownPos.x,
                top: dropdownPos.y
            }}
             className={"context-menu " + className}>
          {children}
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContextMenu);
